var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangPluseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58398 2.91634C7.58398 2.59418 7.32282 2.33301 7.00065 2.33301C6.67848 2.33301 6.41732 2.59418 6.41732 2.91634V6.41634H2.91732C2.59515 6.41634 2.33398 6.67751 2.33398 6.99967C2.33398 7.32184 2.59515 7.58301 2.91732 7.58301H6.41732V11.083C6.41732 11.4052 6.67848 11.6663 7.00065 11.6663C7.32282 11.6663 7.58398 11.4052 7.58398 11.083V7.58301H11.084C11.4062 7.58301 11.6673 7.32184 11.6673 6.99967C11.6673 6.67751 11.4062 6.41634 11.084 6.41634H7.58398V2.91634Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangPluseIcon);
export default __webpack_public_path__ + "static/media/orang-pluse-icon.8394d256dd6a5faf78fbc5ef39cbdf7d.svg";
export { ForwardRef as ReactComponent };